module.exports = __webpack_public_path__ + "img/phone.b07a9320.svg";